import { getBinarySensorLabel } from '../../../strings';
import { BinarySensorType } from '../../../types';
export var useBinarySensorLabel = function (type, labelActive, labelInactive) {
    if (type === BinarySensorType.CUSTOM) {
        return { labelActive: labelActive, labelInactive: labelInactive };
    }
    return getBinarySensorLabel(type);
};
//# sourceMappingURL=useBinarySensorLabel.js.map